import { motion } from 'framer-motion';
import { FaSatelliteDish, FaShieldAlt, FaIdCard, FaRupeeSign, FaClock, FaFileContract } from 'react-icons/fa';
import { WHY_CHOOSE_US, IMG } from '../../data/siteData';
import './WhyChooseUs.css';

const ICONS = { FaSatelliteDish, FaShieldAlt, FaIdCard, FaRupeeSign, FaClock, FaFileContract };

export default function WhyChooseUs() {
  return (
    <section className="section why-choose">
      <div className="container why-choose__grid">
        <motion.div
          className="why-choose__media"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.9 }}
        >
          <img src={IMG.nightStreet} alt="Ambadykannan Transport truck on a night route" loading="lazy" />
        </motion.div>

        <div>
          <p className="eyebrow">Why Choose Us</p>
          <h2 className="section-title">Engineered For<br />Trust At Scale.</h2>

          <div className="why-choose__list">
            {WHY_CHOOSE_US.map((f, i) => {
              const Icon = ICONS[f.icon];
              return (
                <motion.div
                  className="why-choose__item"
                  key={f.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-60px' }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                >
                  <span className="why-choose__icon">{Icon && <Icon />}</span>
                  <div>
                    <h4>{f.title}</h4>
                    <p>{f.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
